export const breadcrumb = {
  notification: {
    title: 'Notifications'
  }
};
